import { blobResponseHandler, downloadBlob, providesList } from '@/shared/helpers/api';
import { createCrossdockingHubCacheListener, createSocketMessageEventListener } from '@/warehouse/signalR';
import { t } from '@/core/localization';
import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
import { baseApi } from '@/warehouse/baseApi';
import { appLocalStorage } from '@/warehouse/helpers';
import { getCrossdockIdFromStorage } from '@/warehouse/helpers/getCrossdockIdFromStorage';
import { createOrDeleteStickerItemMessageSchema } from '@/warehouse/signalR/types/messages/CreateOrDeleteStickerItemSocketMessage.yup';
import { crossdockReceiptActions } from './crossdockReceipt.state';
import { updateInvoicesByMessage } from './helpers';
import { fixInvoiceMessage } from './helpers/fixInvoiceMessage';
import { updateVerificationReceiptItemsByMessage } from './helpers/updateVerificationReceiptItemsByMessage';
export const crossdockReceiptApi = baseApi
    .enhanceEndpoints({ addTagTypes: ['Invoices', 'ReceiptItems', 'StickerItems'] })
    .injectEndpoints({
    endpoints: (builder) => ({
        getInvoices: builder.query({
            query: ({ refetch, ...body }) => ({
                url: `crossdocking/${getCrossdockIdFromStorage()}/receipt/invoices`,
                method: 'POST',
                body,
            }),
            // transformResponse: (response: Invoice[]) =>
            // 	response.map((invoice) => ({
            // 		...invoice,
            // 		invoiceDate: new Date(invoice.invoiceDate),
            // 	})),
            providesTags: (result) => providesList(result, 'Invoices', 'invoiceId'),
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled;
                    dispatch(crossdockReceiptActions.setInboxItemCount(data?.length));
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.invoices.request.failed'), error }));
                }
            },
            onCacheEntryAdded: createCrossdockingHubCacheListener(({ updateCachedData, getCacheEntry }, queryArgument) => ({
                CreateOrDeleteStickerItem: createSocketMessageEventListener({
                    endpointName: getCacheEntry().endpointName,
                    queryArgument,
                    validationSchema: createOrDeleteStickerItemMessageSchema,
                    // validationSchemaPath: 'stockInvoice',
                    messageMutation: (message) => {
                        // TODO: to delete later (this is backend bugs fixes)
                        fixInvoiceMessage(message);
                    },
                    listener: ({ validQueryArgument, ...args }) => {
                        updateCachedData((draft) => {
                            // // Updating notReceiptedInvoices counter, we must take in account that some of this invoices may be actually receipted,
                            // // but still exist in the list, since they were just marked as receipted (greed background) by socket message.
                            // /// const prevItemCount = draft.length; // <= that is not enough
                            // const prevItemCount = validQueryArgument.isReceipted
                            // 	? draft.length
                            // 	: draft.filter((item) => item.quantity !== item.receiptedQuantity).length;
                            updateInvoicesByMessage({ draft, isReceipted: validQueryArgument.accepted, ...args });
                            // const nextItemCount = validQueryArgument.isReceipted
                            // 	? draft.length
                            // 	: draft.filter((item) => item.quantity !== item.receiptedQuantity).length;
                            // if (prevItemCount !== nextItemCount) {
                            // 	// // TODO: to delete
                            // 	// console.log('updated, queryArgument.isReceipted', queryArgument.isReceipted);
                            // 	// console.log('updated, validQueryArgument.isReceipted', validQueryArgument.isReceipted);
                            // 	// console.log('updated, prevItemCount', prevItemCount);
                            // 	// console.log('updated, nextItemCount', nextItemCount);
                            // 	dispatch(
                            // 		validQueryArgument.isReceipted
                            // 			? stockReceiptActions.setReceiptedInvoiceCount(nextItemCount)
                            // 			: stockReceiptActions.setNotReceiptedInvoiceCount(nextItemCount)
                            // 	);
                            // }
                        });
                    },
                }),
            })),
        }),
        // TODO: later, remove verification tab logic, it has been already moved out to getVerificationItems.
        getInvoiceReceiptItems: builder.query({
            query: ({ invoiceId }) => ({
                url: `crossdocking/${getCrossdockIdFromStorage()}/receipt/items`,
                method: 'POST',
                // Different queries: for Verification tab - only IsBlocked flag is valid; for Invoice receiptItems - only invoiceId.
                body: { invoiceId },
            }),
            onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
                try {
                    const result = await queryFulfilled;
                    // dispatch(receiptActions.setVerificationItemCount(result.data.receiptItems?.length));
                    dispatch(crossdockReceiptActions.setInboxItemCount(result.data.receiptItems?.length));
                }
                catch {
                    //
                }
            },
            onCacheEntryAdded: createCrossdockingHubCacheListener(({ updateCachedData, getCacheEntry }, queryArgument) => ({
                CreateOrDeleteStickerItem: createSocketMessageEventListener({
                    endpointName: getCacheEntry().endpointName,
                    queryArgument,
                    validationSchema: createOrDeleteStickerItemMessageSchema,
                    // validationSchemaPath: 'stockInvoice',
                    messageMutation: (message) => {
                        // TODO: to delete later (this is backend bugs fixes)
                        fixInvoiceMessage(message);
                    },
                    listener: ({ message }) => {
                        updateCachedData((draft) => {
                            // TODO: to delete
                            // console.log('getReceiptItems, onCacheEntryAdded in updateCachedData, draft:', draft);
                            // console.log('getReceiptItems, onCacheEntryAdded in updateCachedData, message:', message);
                            const receiptItemIndex = draft.receiptItems.findIndex((item) => item.receiptItemId === message.receiptItemId);
                            if (receiptItemIndex === -1)
                                return;
                            draft.receiptItems[receiptItemIndex].receiptedQuantity = message.itemReceiptedQuantity;
                            draft.receiptItems[receiptItemIndex].blockedQuantity = message.itemBlockedQuantity;
                            if (draft.invoice) {
                                draft.invoice.receiptedQuantity = message.invoiceReceiptedQuantity;
                                draft.invoice.blockedQuantity = message.invoiceBlockedQuantity;
                            }
                            // TODO:
                            // If the Verification tab is active and therefore receiptItems endpoint with IsBlocked flag is used,
                            // we should probably remove receiptItem with not found receiptItemIndex, because it probably has 0
                            // available items and does not exist on query result anymore.
                            // We should even try to separate current endpoint by 'IsBlocked' (for Verification tab) and
                            // 'invoiceId' for Invoice receiptItems to have a possibility to react on socket updates in different
                            // ways (to remove or not to remove receiptItem).
                            // TODO: check for draft.invoice is valid (later). May be it is not even necessary
                            // const itemIndex = draft.receiptItems.findIndex((item) => item.receiptItemId === data.receiptItemId);
                            // if (itemIndex !== -1) draft.receiptItems[itemIndex].receiptedQuantity = data.receiptItemQuantity;
                        });
                    },
                }),
            })),
        }),
        getVerificationReceiptItems: builder.query({
            query: () => ({
                url: `crossdocking/${getCrossdockIdFromStorage()}/receipt/items`,
                method: 'POST',
                body: { IsBlocked: false },
            }),
            transformResponse: (response) => response.receiptItems,
            onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
                try {
                    const result = await queryFulfilled;
                    dispatch(crossdockReceiptActions.setVerificationItemCount(result.data.length));
                }
                catch {
                    //
                }
            },
            onCacheEntryAdded: createCrossdockingHubCacheListener(({ updateCachedData, getCacheEntry }) => ({
                CreateOrDeleteStickerItem: createSocketMessageEventListener({
                    endpointName: getCacheEntry().endpointName,
                    validationSchema: createOrDeleteStickerItemMessageSchema,
                    messageMutation: (message) => {
                        // TODO: to delete later (this is backend bugs fixes)
                        fixInvoiceMessage(message);
                    },
                    listener: (args) => {
                        updateCachedData((draft) => {
                            updateVerificationReceiptItemsByMessage({ draft, ...args });
                        });
                    },
                }),
            })),
        }),
        confirmReceiptItem: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: `crossdocking/${getCrossdockIdFromStorage()}/receipt/sticker`,
                body: { ...body, printerName: appLocalStorage.getItem('printerName') },
            }),
            invalidatesTags: (result, error) => 
            // Prevents update tags on error.
            // 'result' is null in case of successful POST, so 'error' must be checked.
            error ? [] : [{ type: 'StickerItems', id: 'LIST' }],
            // TODO: this `onQueryStarted` should be removed, only fixed socket messages should be used to update data.
            // Fixed means that we have new data, but not only current changes.
            onQueryStarted: async (request, { dispatch, queryFulfilled }) => {
                // const ownerLocation = (getState() as RootState).crossdockReceipt.ownerLocation;
                const { receiptItemId, quantity, isBlocked, invoiceId } = request;
                // const receiptItemsRequestPayload: GetReceiptItemsRequest = {
                // 	...(ownerLocation === 'invoice' ? { invoiceId } : { blocked: ownerLocation !== 'verification' }),
                // };
                // Optimistic update.
                const patchResult = dispatch(crossdockReceiptApi.util.updateQueryData('getInvoiceReceiptItems', { invoiceId }, (draft) => {
                    const patch = {
                        // ...draft,
                        // @ts-expect-error what is wrong with typescript?? it was working pretty well.
                        // Data from invoice is used in Invoice progress, so it should also be updated.
                        invoice: 
                        // If `invoiceId` is defined then work with Invoice (UTD list) is in process.
                        // That means `draft.invoice` is not null and contains required data.
                        invoiceId
                            ? {
                                ...draft.invoice,
                                ...(isBlocked
                                    ? { blockedQuantity: draft.invoice.blockedQuantity + quantity }
                                    : { receiptedQuantity: draft.invoice.receiptedQuantity + quantity }),
                            }
                            : // If `invoiceId` is undefined (and `IsBlocked` is defined) then work with Verification tab is in process.
                                // And `draft.invoice` is null in this case.
                                null,
                        receiptItems: draft.receiptItems.map((receiptItem) => receiptItem.receiptItemId === receiptItemId
                            ? {
                                ...receiptItem,
                                ...(isBlocked
                                    ? { blockedQuantity: receiptItem.blockedQuantity + quantity }
                                    : { receiptedQuantity: receiptItem.receiptedQuantity + quantity }),
                            }
                            : receiptItem),
                    };
                    Object.assign(draft, patch);
                }));
                //
                // Verification tab case.
                //
                // Optimistic update.
                dispatch(crossdockReceiptApi.util.updateQueryData('getVerificationReceiptItems', undefined, (draft) => {
                    const patch = draft.map((receiptItem) => receiptItem.receiptItemId === receiptItemId
                        ? {
                            ...receiptItem,
                            receiptedQuantity: receiptItem.receiptedQuantity + quantity,
                        }
                        : receiptItem);
                    Object.assign(draft, patch);
                }));
                try {
                    await queryFulfilled;
                }
                catch {
                    patchResult.undo();
                    // Alternatively, on failure we can invalidate the corresponding cache tags
                    // to trigger a re-fetch:
                    // dispatch(api.util.invalidateTags(['Post']))
                }
            },
        }),
        // TODO: check if we need this endpoint , mb confirmReceiptItem should be used for 4 different cases.
        acceptTrackableReceiptItem: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: `crossdocking/${getCrossdockIdFromStorage()}/receipt/sticker`, // TODO: CONTINUEHERE check!
                body: { ...body, printerName: appLocalStorage.getItem('printerName') },
            }),
            invalidatesTags: (result, error, { invoiceId }) => 
            // Prevents update tags on error.
            // 'result' is null in case of successful POST, so 'error' must be checked.
            error
                ? []
                : [
                    { type: 'Invoices', id: invoiceId },
                    // 'ReceiptItems' invalidation is not to be used here, we manually update items in onQueryStarted with
                    // pessimistic update.
                    // { type: 'ReceiptItems', id: receiptItemId },
                    { type: 'StickerItems', id: 'LIST' },
                ],
            onQueryStarted: async (request, { dispatch, queryFulfilled }) => {
                // const ownerLocation = (getState() as RootState).crossdockReceipt.ownerLocation;
                // const { receiptItemId, quantity, isBlocked, invoiceId } = request;
                const { receiptItemId, isBlocked, invoiceId } = request;
                // Trackable item can only be accepted by a single piece.
                const quantity = 1;
                // const receiptItemsRequestPayload: GetReceiptItemsRequest = {
                // 	...(ownerLocation === 'invoice' ? { invoiceId } : { blocked: ownerLocation !== 'verification' }),
                // };
                // Optimistic update.
                const patchResult = dispatch(crossdockReceiptApi.util.updateQueryData('getInvoiceReceiptItems', { invoiceId }, (draft) => {
                    const patch = {
                        // ...draft,
                        // @ts-expect-error what is wrong with typescript?? it was working pretty well.
                        // Data from invoice is used in Invoice progress, so it should also be updated.
                        invoice: 
                        // If `invoiceId` is defined then work with Invoice (UTD list) is in process.
                        // That means `draft.invoice` is not null and contains required data.
                        invoiceId
                            ? {
                                ...draft.invoice,
                                ...(isBlocked
                                    ? { blockedQuantity: draft.invoice.blockedQuantity + quantity }
                                    : { receiptedQuantity: draft.invoice.receiptedQuantity + quantity }),
                            }
                            : // If `invoiceId` is undefined (and `IsBlocked` is defined) then work with Verification tab is in process.
                                // And `draft.invoice` is null in this case.
                                null,
                        receiptItems: draft.receiptItems.map((receiptItem) => receiptItem.receiptItemId === receiptItemId
                            ? {
                                ...receiptItem,
                                ...(isBlocked
                                    ? { blockedQuantity: receiptItem.blockedQuantity + quantity }
                                    : { receiptedQuantity: receiptItem.receiptedQuantity + quantity }),
                            }
                            : receiptItem),
                    };
                    Object.assign(draft, patch);
                }));
                //
                // Verification tab case.
                //
                // Optimistic update.
                dispatch(crossdockReceiptApi.util.updateQueryData('getVerificationReceiptItems', undefined, (draft) => {
                    const patch = draft.map((receiptItem) => receiptItem.receiptItemId === receiptItemId
                        ? {
                            ...receiptItem,
                            receiptedQuantity: receiptItem.receiptedQuantity + quantity,
                        }
                        : receiptItem);
                    Object.assign(draft, patch);
                }));
                try {
                    await queryFulfilled;
                }
                catch {
                    patchResult.undo();
                    // Alternatively, on failure we can invalidate the corresponding cache tags
                    // to trigger a re-fetch:
                    // dispatch(api.util.invalidateTags(['Post']))
                }
            },
        }),
        revokeReceiptItem: builder.mutation({
            query: ({ stickers }) => ({
                method: 'DELETE',
                url: `crossdocking/${getCrossdockIdFromStorage()}/receipt/sticker`,
                body: { stickerIds: stickers.map((item) => item.stickerId) },
            }),
            invalidatesTags: (result, error, { invoiceId }) => 
            // Prevents update tags on error.
            // 'result' is null in case of successful POST, so 'error' must be checked instead of 'result'.
            error
                ? []
                : [
                    { type: 'Invoices', id: invoiceId },
                    // 'ReceiptItems' invalidation is not to be used here, we manually update items in onQueryStarted with
                    // pessimistic update.
                    // { type: 'ReceiptItems', id: receiptItemId },
                    { type: 'StickerItems', id: 'LIST' },
                ],
        }),
        getStickers: builder.query({
            query: ({ receiptItemId, isBlocked }) => ({
                method: 'GET',
                url: 'crossdocking/receipt/sticker',
                params: {
                    crossdockingId: getCrossdockIdFromStorage(),
                    receiptItemId,
                    isBlocked,
                },
            }),
            onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.stickers.request.failed'), error }));
                }
            },
            transformResponse: (response) => response.map((stickerItem) => ({
                ...stickerItem,
                createDate: new Date(stickerItem.createDate),
            })),
            providesTags: () => [{ type: 'StickerItems', id: 'LIST' }],
        }),
        // TODO: to delete later during refactoring of Crossdocking receipt
        getStickerItems: builder.query({
            query: (body) => ({
                method: 'POST',
                url: 'receipt/stickerItems',
                body,
            }),
            onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.stickers.request.failed'), error }));
                }
            },
            transformResponse: (response) => response.map((stickerItem) => ({
                ...stickerItem,
                createDate: new Date(stickerItem.createDate),
            })),
            providesTags: () => [{ type: 'StickerItems', id: 'LIST' }],
        }),
        exportInvoiceToExcel: builder.mutation({
            queryFn: async ({ receiptItems }, api, extraOptions, baseQuery) => downloadBlob({
                queryResult: await baseQuery({
                    method: 'POST',
                    cache: 'no-cache',
                    url: 'receipt/xlsx',
                    body: receiptItems,
                    responseHandler: blobResponseHandler,
                }),
                fileName: `${'receipts'}.xlsx`,
            }),
        }),
    }),
});
export const { useGetInvoicesQuery, useGetInvoiceReceiptItemsQuery, useGetVerificationReceiptItemsQuery, useGetStickerItemsQuery, useGetStickersQuery, useExportInvoiceToExcelMutation, } = crossdockReceiptApi;
